<section class="user-profile">

  <div class="row">
    <div class="col-12">
      <div class="media d-flex align-items-center">
        <a href="javascript:;">
          <img src="assets/app/img/default-no-image.png" alt="user view avatar" class="users-avatar-shadow rounded"
            height="64" width="64">
        </a>
        <div class="media-body ml-3">
          <h4>
            <span class="users-view-name mr-1">{{UserProfileDataForm.get('Name')?.value}}</span>
            <a class="float-right" (click)="EditUserProfile()"><i class="{{editUserProfileClass}} mr-2"></i></a>
          </h4>
          <span class="badge bg-light-success users-view-status">Active</span>
        </div>
      </div>
    </div>
  </div>

  <section #ViewUserProfileSection>

    <div class="row pt-2">
      <div class="col-12">
        <h5 class="mb-2 text-bold-500">
          <i class="fa-solid fa-circle-user mr-2"></i> Account Info
        </h5>
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-5">Registered</div>
                <div class="col-7">{{UserProfileDataForm.get('DateCreated')?.value | date:'dd/MM/yyyy'}}</div>
              </div>
              <div class="row">
                <div class="col-5">Username</div>
                <div class="col-7">{{UserProfileDataForm.get('Username')?.value}}</div>
              </div>
              <div class="row">
                <div class="col-5">OTP</div>
                <div class="col-7"><input type="checkbox" [disabled]="true"
                    [checked]="UserProfileDataForm.get('RequireOTP')?.value" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-2">
      <div class="col-12">
        <h5 class="mb-2 text-bold-500"><i class="fa-solid fa-user-large mr-2"></i> Personal Info
          <a class="float-right" *ngIf="UserProfileDataForm.get('hasExtendedInfo')?.value"
            (click)="LoadExtendedInformation()">
            <i class="fa-solid fa-ellipsis mr-2"> more info</i>
          </a>
        </h5>
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-5">Name:</div>
                <div class="col-7">{{UserProfileDataForm.get('Name')?.value}}</div>
              </div>
              <div class="row">
                <div class="col-5">e-mail:</div>
                <div class="col-7">{{UserProfileDataForm.get('Email')?.value}}</div>
              </div>
              <div class="row">
                <div class="col-5">Phone:</div>
                <div class="col-7">{{UserProfileDataForm.get('Mobile')?.value}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-2">
      <div class="col-12">
        <h5 class="mb-2 text-bold-500"><i class="fa-solid fa-tablet-screen-button mr-2"></i> Application Info</h5>
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-5">Project:</div>
                <div class="col-7">{{UserProfileDataForm.get('Project')?.value}}</div>
              </div>
              <div class="row">
                <div class="col-5">App Owner:</div>
                <div class="col-7">{{UserProfileDataForm.get('Instance')?.value}}</div>
              </div>
              <div class="row">
                <div class="col-5">App Title:</div>
                <div class="col-7">{{UserProfileDataForm.get('InstanceTitle')?.value}}</div>
              </div>
              <div class="row">
                <div class="col-5">Group:</div>
                <div class="col-7">{{UserProfileDataForm.get('GroupName')?.value}}</div>
              </div>
              <div class="row">
                <div class="col-5">Role:</div>
                <div class="col-7">{{UserProfileDataForm.get('RoleName')?.value}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div #EditUserProfileSection class="row pt-2 d-none">
    <form [formGroup]="UserProfileDataForm">
      <div class="col-12">
        <h5 class="mb-2 text-bold-500">
          <i class="fa-solid fa-id-card-clip mr-2"></i> Profile Changes
        </h5>
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <mat-form-field>
                <input matInput type="text" placeholder="{{ 'app.trn-name' | translate }}" formControlName="Name">
              </mat-form-field>
              <mat-form-field>
                <input matInput type="text" placeholder="{{ 'app.trn-email' | translate }}" formControlName="Email">
              </mat-form-field>
              <mat-form-field>
                <input matInput type="number" placeholder="{{ 'app.trn-phone' | translate }}" formControlName="Mobile">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="col-12">
      <h5 class="mb-2 text-bold-500">
        <i class="fa-solid fa-key mr-2"></i> Password Reset
        <a class="float-right" (click)="RequestNewPassword()">
          <i class="{{UserPasswordClass}} mr-2"></i>
        </a>
      </h5>
      <form [formGroup]="UserNewPasswordRequestForm">
        <div class="card">
          <div class="card-content">
            <div class="card-body">

              <mat-form-field>
                <mat-label>
                  <span class="app-label-icon pr-1"><i class="fa-solid fa-key"></i></span>
                  <span>{{ 'app.trn-type-old-password' | translate }}</span>
                </mat-label>
                <input matInput [type]="HiddenOldPassword ? 'password' : 'text'" formControlName="OldPassword">
                <mat-icon class="cursor-pointer" matSuffix (click)="HiddenOldPassword = !HiddenOldPassword">{{HiddenOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field>

              <mat-form-field>
                <mat-label>
                  <span class="app-label-icon pr-1"><i class="fa-solid fa-lock"></i></span>
                  <span>{{ 'app.trn-type-password' | translate }}</span>
                </mat-label>
                <input matInput [type]="HiddenPassword ? 'password' : 'text'" formControlName="Password">
                <mat-icon class="cursor-pointer" matSuffix (click)="HiddenPassword = !HiddenPassword">{{HiddenPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field>

              <mat-form-field>
                <mat-label>
                  <span class="app-label-icon pr-1"><i class="fa-solid fa-lock"></i></span>
                  <span>{{ 'app.trn-retype-password' | translate }}</span>
                </mat-label>
                <input matInput [type]="HiddenRetypePassword ? 'password' : 'text'" formControlName="PasswordRetype">
                <mat-icon class="cursor-pointer" matSuffix (click)="HiddenRetypePassword = !HiddenRetypePassword">{{HiddenRetypePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field>



              <!-- <mat-form-field>
                <mat-label>
                  <span>{{ 'app.trn-type-old-password' | translate }}</span>
                </mat-label>
                <input matInput type="password" formControlName="OldPassword" />
              </mat-form-field> -->
              <!-- <mat-form-field>
                <mat-label>
                  <span>{{ 'app.trn-type-password' | translate }}</span>
                </mat-label>
                <input matInput type="password" formControlName="Password" />
              </mat-form-field> -->
              <!-- <mat-form-field>
                <mat-label>
                  <span>{{ 'app.trn-retype-password' | translate }}</span>
                </mat-label>
                <input matInput type="password" formControlName="PasswordRetype" />
              </mat-form-field> -->

              <mat-error
                *ngIf="UserNewPasswordRequestForm.hasError('passwordsMismatch') && UserNewPasswordRequestForm.get('PasswordRetype').touched">
                {{ 'app.trn-validator-password-not-match' | translate }}
              </mat-error>
              <mat-error
                *ngIf="UserNewPasswordRequestForm.get('Password').hasError('required') && UserNewPasswordRequestForm.get('Password').touched">
                {{ 'app.trn-validator-password-required' | translate }}
              </mat-error>
              <mat-error
                *ngIf="UserNewPasswordRequestForm.get('Password').invalid && !UserNewPasswordRequestForm.get('Password').hasError('required') && UserNewPasswordRequestForm.get('Password').touched ">
                {{ 'app.trn-validator-at-least-xxx-characters' | translate }}
              </mat-error>
              <mat-error
                *ngIf="UserNewPasswordRequestForm.get('Password').invalid && !UserNewPasswordRequestForm.get('Password').hasError('required') && UserNewPasswordRequestForm.get('Password').touched">
                <ul style="margin:0 0 8px 0">
                  <li>Uppercase</li>
                  <li>Lowercase</li>
                  <li>Number</li>
                  <li>Non-alpha numeric</li>
                </ul>
              </mat-error>

            </div>
          </div>
        </div>
      </form>

      <div class="UserProfileFooter">
        <div>
          <div>
            <i (click)="SaveProfileChanges();" class="btn btn-success btn-lg btn-block btn-raised">{{
              'app.trn-save-changes' | translate }}</i>
          </div>
        </div>
      </div>


    </div>
  </div>

</section>